export default {
  install(Vue, options) {
    Vue.prototype.$Report = {
      EventResourceArr:[],
      //自動表格編號
      AddRecordNo(Obj){
        for(var i = 0 ; i < Obj.length ; i++){
          Obj[i].recordno = i+1
        }
      },
      //Auto Email 加報表步驟 10 新增AutoEmail顯示參數
      CanVotaDetailAutoEmailSetShow:false,
      CanVotaDetailAutoEmailSetShowNum:0,
      cangoDetailAutoEmailSetShow:false,
      cangoDetailAutoEmailSetShowNum:0,
      PositionLogDetailAutoEmailSetShow:false,
      PositionLogDetailAutoEmailSetShowNum:0,
      TripDetailAutoEmailSetShow:false,
      TripDetailAutoEmailSetShowNum:0,
      PairedEventDetailAutoEmailSetShow:false,
      PairedEventDetailAutoEmailSetShowNum:0,
      AlertEventDetailAutoEmailSetShow:false,
      AlertEventDetailAutoEmailSetShowNum:0,
      TripSummaryAutoEmailSetShow:false,
      TripSummaryAutoEmailSetShowNum:0,
      MileageDaySummaryAutoEmailSetShow:false,
      MileageDaySummaryAutoEmailSetShowNum:0,
      MileageMonthSummaryAutoEmailSetShow:false,
      MileageMonthSummaryAutoEmailSetShowNum:0,
      FuelEstimationMonthSummaryAutoEmailSetShow:false,
      FuelEstimationMonthSummaryAutoEmailSetShowNum:0,
      EventSummaryAutoEmailSetShow:false,
      EventSummaryAutoEmailSetShowNum:0,
      VehicleAliveReportAutoEmailSetShow:false,
      VehicleAliveReportAutoEmailSetShowNum:0,
      AutoEmailInputShow:false,
      AutoEmailInputShowNum:0,
      getAutoEmailListNum:0,
      AutoEmailInputObj:''
    }
  }
}




// WEBPACK FOOTER //
// ./src/Report.js